export default {
  ZH_HK: {
    topicNum: "題目數量",
    area: "區域",
    language: "語言",
    selected: "已選",
    question: "題",
    selectAll: "全部選擇",
    next: "下一步",
    done: "完成",
    selectNone: "請選擇至少一個問題",
    empty: "還沒有題目",
    emptyTips: "請先選擇題目",
    input: "輸入",
    working: "正在生成題目",
    invert: "全不選",
    relateQuestionBank: "關聯題庫",
    selectDepartment: "選擇學科",
    atThisDifficulty: "難度",
    noSubject: "沒有學科",
    bankName: "題庫名稱",
    confirm: "確定",
    cancel: "取消",
    questionNameIsNotFilledIn: "題庫名稱未填寫",
    noTopicSelect: "未選擇學科",
    added: "已添加到題庫",
    generationTip: "正在生成題目",
    wait: "請等待題目生成完畢"
  },
  EN: {
    topicNum: "No. of questions",
    area: "Countries and regions",
    language: "Language",
    question: "question(s)",
    selected: "Select",
    selectAll: "Select All",
    next: "Next",
    done: "Done",
    selectNone: "Please select at least one question",
    empty: "No Question",
    emptyTips: "Please select a question first",
    input: "Input",
    working: "Working",
    invert: "Invert All",
    relateQuestionBank: "Relate Question Bank",
    selectDepartment: "Select Topic",
    atThisDifficulty: "There are no subjects at difficulty ",
    noSubject: "",
    bankName: "Question Bank Name",
    confirm: "Confirm",
    cancel: "Cancel",
    questionNameIsNotFilledIn: "Question bank name is not filled In",
    noTopicSelect: "No topic select",
    added: "Added to question bank",
    generationTip: "Generating questions",
    wait: "The topic is being generated, please wait"
  },
  zh_cn: {
    topicNum: "题目数量",
    area: "区域",
    language: "语言",
    selected: "已选",
    question: "题",
    selectAll: "全部选择",
    next: "下一步",
    done: "完成",
    selectNone: "请选择至少一个问题",
    empty: "还没有题目",
    emptyTips: "请先选择题目",
    input: "输入",
    working: "正在生成题目",
    invert: "全不选",
    relateQuestionBank: "关联题库",
    selectDepartment: "选择学科",
    atThisDifficulty: "难度",
    noSubject: "没有学科",
    bankName: "题库名称",
    confirm: "确定",
    cancel: "取消",
    questionNameIsNotFilledIn: "题库名称未填写",
    noTopicSelect: "未选择学科",
    added: "已添加到题库",
    generationTip: "正在生成题目",
    wait: "请等待题目生成完毕"
  },
  es: {
    topicNum: "Número de preguntas",
    area: "Área",
    language: "Idioma",
    selected: "Seleccionado(s)",
    question: "Pregunta(s)",
    selectAll: "Seleccionar todo",
    next: "Siguiente",
    done: "Finalizar",
    selectNone: "Seleccione al menos una pregunta",
    empty: "Sin preguntas",
    emptyTips: "Seleccione preguntas primero",
    input: "Ingresar",
    working: "Generando preguntas",
    invert: "Deseleccionar todo",
    relateQuestionBank: "Vincular banco de preguntas",
    selectDepartment: "Seleccionar asignatura",
    atThisDifficulty: "Dificultad",
    noSubject: "Sin asignaturas",
    bankName: "Nombre del banco",
    confirm: "Confirmar",
    cancel: "Cancelar",
    questionNameIsNotFilledIn: "Nombre no ingresado",
    noTopicSelect: "Asignatura no seleccionada",
    added: "Añadido al banco",
    generationTip: "Generando preguntas",
    wait: "Espere a que se generen"
  }
};
